import { createFileRoute, Navigate } from '@tanstack/react-router'
import { defaultAdminPath, getStoredUserRole } from '@/lib/staff-roles'
import { useEdition } from '@/hooks/useEdition'

export const Route = createFileRoute('/admin/')({
  component: AdminIndexRedirect,
})

// Used to hard-redirect to /admin/dashboard, which on marketing-edition
// deploys double-hopped through the POS-path guard in routes/admin.tsx.
// Resolve the edition first and land in one hop; if the settings fetch
// fails, fall back to the full-POS path and let the guard sort it out
// (never route on an unresolved edition — the E-P3 rule).
function AdminIndexRedirect() {
  const { posEnabled, isLoading, isError } = useEdition()
  if (isLoading && !isError) return null
  return (
    <Navigate
      to={defaultAdminPath(getStoredUserRole(), isError ? true : posEnabled)}
      replace
    />
  )
}
